import { render, staticRenderFns } from "./OrganizationListItem.vue?vue&type=template&id=5fba500c&scoped=true&"
import script from "./OrganizationListItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationListItem.vue?vue&type=style&index=0&id=5fba500c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fba500c",
  null
  
)

export default component.exports